(function () {
  const CONTAINER_SELECTORS = ['#cross-sell', '#upsell', '#xs_bundle'];
  const CAROUSEL_HEIGHT_OFFSET = 40;

  const waitForImages = (container) => {
    const images = container.querySelectorAll('.xs-card img');

    return Promise.all(
      Array.from(images).map((image) => {
        if (image.complete) return Promise.resolve();

        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      })
    );
  };

  const resetCarouselHeight = (container) => {
    container.style.removeProperty('--xs-carousel-height');

    container.querySelectorAll('.flickity-viewport, .flickity-slider').forEach((element) => {
      element.style.height = '';
      element.style.minHeight = '';
    });
  };

  const applyCarouselHeight = (container, cardHeight) => {
    if (cardHeight <= 0) return;

    const carouselHeight = cardHeight + CAROUSEL_HEIGHT_OFFSET;

    container.style.setProperty('--xs-carousel-height', `${carouselHeight}px`);

    container.querySelectorAll('.flickity-viewport, .flickity-slider').forEach((element) => {
      element.style.height = `${carouselHeight}px`;
      element.style.minHeight = `${carouselHeight}px`;
    });
  };

  const measureMaxCardHeight = (cards) => {
    let maxCardHeight = 0;

    cards.forEach((card) => {
      maxCardHeight = Math.max(
        maxCardHeight,
        card.offsetHeight,
        card.scrollHeight,
        card.getBoundingClientRect().height
      );
    });

    return maxCardHeight;
  };

  const bindFlickityEvents = (container) => {
    container.querySelectorAll('.flickity-enabled').forEach((flickityEl) => {
      if (flickityEl.dataset.xsHeightBound === 'true') return;
      flickityEl.dataset.xsHeightBound = 'true';

      flickityEl.addEventListener('ready', scheduleEqualize);

      if (!window.Flickity) return;

      const instance = window.Flickity.data(flickityEl);
      if (!instance) return;

      instance.on('settle', () => {
        const heightValue = container.style.getPropertyValue('--xs-carousel-height');
        if (!heightValue) return;
        applyCarouselHeight(container, parseFloat(heightValue));
      });
    });
  };

  const syncFlickityInstances = (container, cardHeight) => {
    const flickityElements = container.querySelectorAll('.flickity-enabled');

    flickityElements.forEach((flickityEl) => {
      if (!window.Flickity) return;

      const instance = window.Flickity.data(flickityEl);
      if (!instance) return;

      instance.options.adaptiveHeight = false;
      instance.resize();
      applyCarouselHeight(container, cardHeight);
    });
  };

  const equalizeCards = (container) => {
    const cards = container.querySelectorAll('.xs-card');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.minHeight = '';
      const imageWrap = card.querySelector('.xs-image');
      if (!imageWrap) return;
      imageWrap.style.height = '';
      imageWrap.classList.remove('xs-image--sized');
    });

    resetCarouselHeight(container);

    let maxImageHeight = 0;

    cards.forEach((card) => {
      const imageWrap = card.querySelector('.xs-image');
      if (!imageWrap) return;
      maxImageHeight = Math.max(maxImageHeight, imageWrap.offsetHeight);
    });

    if (maxImageHeight > 0) {
      cards.forEach((card) => {
        const imageWrap = card.querySelector('.xs-image');
        if (!imageWrap) return;
        imageWrap.style.height = `${maxImageHeight}px`;
        imageWrap.classList.add('xs-image--sized');
      });
    }

    let maxCardHeight = measureMaxCardHeight(cards);
    if (maxCardHeight <= 0) return;

    cards.forEach((card) => {
      card.style.minHeight = `${maxCardHeight}px`;
    });

    maxCardHeight = measureMaxCardHeight(cards);
    applyCarouselHeight(container, maxCardHeight);
    syncFlickityInstances(container, maxCardHeight);

    window.requestAnimationFrame(() => {
      const finalHeight = measureMaxCardHeight(cards);

      cards.forEach((card) => {
        card.style.minHeight = `${finalHeight}px`;
      });

      applyCarouselHeight(container, finalHeight);
      syncFlickityInstances(container, finalHeight);
      bindFlickityEvents(container);
    });
  };

  const equalizeContainer = async (container) => {
    await waitForImages(container);
    equalizeCards(container);
  };

  let resizeTimer;
  let pendingRun = false;

  const scheduleEqualize = () => {
    if (pendingRun) return;
    pendingRun = true;

    window.requestAnimationFrame(() => {
      pendingRun = false;

      CONTAINER_SELECTORS.forEach((selector) => {
        const container = document.querySelector(selector);
        if (container && container.querySelector('.xs-card')) {
          equalizeContainer(container);
        }
      });
    });
  };

  const observeContainer = (container) => {
    const observer = new MutationObserver(scheduleEqualize);
    observer.observe(container, { childList: true, subtree: true });
  };

  const init = () => {
    CONTAINER_SELECTORS.forEach((selector) => {
      const container = document.querySelector(selector);
      if (container) observeContainer(container);
    });

    scheduleEqualize();

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleEqualize, 150);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
